import { Form as FormAntD } from "antd";
import "./Form.scss";
import { useCallback } from "react";

interface FormProps<T = any> {
  children?: React.ReactNode;
  onSubmitForm?: (values: T) => void;
  name?: string;
}

export const Form = <T,>({
  children,
  onSubmitForm,
  name = "form",
}: FormProps<T>) => {
  const onFinish = useCallback(
    (values: T) => {
      if (onSubmitForm) {
        onSubmitForm(values);
      }
    },
    [onSubmitForm],
  );

  return (
    <FormAntD className="cp-form" name={name} onFinish={onFinish}>
      {children}
    </FormAntD>
  );
};

export default Form;
